import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { useTranslation } from 'react-i18next'
import { Box, Stack } from '@chakra-ui/react'
import MegaMenu from './megamenu'
import DropDownMenu from './dropdownMenu'

const MenuComp = () => {
    const data = useStaticQuery(
        graphql`
            query fetchMenu {
                menu: allContentfulMenus(filter: { title: { eq: "MainMenu" } }) {
                    nodes {
                        id
                        title
                        node_locale
                        menuItems {
                            id
                            title
                            megamenu
                            node_locale
                            internal {
                                type
                            }
                            link {
                                ... on ContentfulPage {
                                    id
                                    slug
                                    title

                                    internal {
                                        type
                                    }
                                }
                                ... on ContentfulEduPage {
                                    id
                                    slug
                                    title

                                    internal {
                                        type
                                    }
                                }
                                ... on ContentfulMenulink {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    linkTo
                                }
                                ... on ContentfulRegistrations {
                                    id
                                    slug
                                    title

                                    internal {
                                        type
                                    }
                                }
                            }
                            subItems {
                                ... on ContentfulPage {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    slug
                                }
                                ... on ContentfulRegistrations {
                                    id
                                    slug
                                    title

                                    internal {
                                        type
                                    }
                                }
                                ... on ContentfulMenulink {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    linkTo
                                }
                                ... on ContentfulEduPage {
                                    id
                                    internal {
                                        type
                                    }
                                    title
                                    slug
                                }
                                ... on ContentfulMenuItems {
                                    id
                                    title
                                    link {
                                        ... on ContentfulPage {
                                            id
                                            slug
                                            title
                                            internal {
                                                type
                                            }
                                        }
                                        ... on ContentfulEducationalLevels {
                                            id
                                            slug
                                            title
                                            order
                                            internal {
                                                type
                                            }
                                        }
                                    }
                                    internal {
                                        type
                                    }
                                    subItems {
                                        ... on ContentfulEduPage {
                                            id
                                            internal {
                                                type
                                            }
                                            title
                                            slug
                                        }
                                        ... on ContentfulMenuItems {
                                            id
                                            title
                                            internal {
                                                type
                                            }
                                            link {
                                                ... on ContentfulEduPage {
                                                    id
                                                    title
                                                    slug
                                                    internal {
                                                        type
                                                    }
                                                }
                                                ... on ContentfulPage {
                                                    id
                                                    title
                                                    slug
                                                    internal {
                                                        type
                                                    }
                                                }
                                                ... on ContentfulEducationalLevels {
                                                    id
                                                    slug
                                                    title
                                                    order
                                                    internal {
                                                        type
                                                    }
                                                }
                                            }
                                        }
                                        ... on ContentfulPage {
                                            id
                                            internal {
                                                type
                                            }
                                            title
                                            slug
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `
    )

    const { i18n } = useTranslation()

    return (
        <Box>
            {data.menu.nodes.map(
                (item) =>
                    item.node_locale === i18n.language && (
                        <Stack
                            key={item.id}
                            direction={'row'}
                            spacing={2}
                            flexWrap={'wrap'}
                            justifyContent={'flex-end'}
                            flexDirection={'row'}
                        >
                            {item.menuItems.map((menu) => (
                                <div key={menu.title}>
                                    {menu.megamenu === 'yes' && <MegaMenu menu={menu} />}
                                    {menu.megamenu === 'no' && <DropDownMenu menu={menu} />}
                                </div>
                            ))}
                        </Stack>
                    )
            )}
        </Box>
    )
}

export default MenuComp
